import React, { useContext, useState, useEffect } from 'react';
import proyectoContext from '../../context/proyectos/proyectoContext';
import TareaContext from '../../context/tareas/tareaContext';

const FormTarea = () => {
    //extraer si un proyecto esta activo
    const proyectosContext = useContext(proyectoContext);
    const {proyecto} = proyectosContext;

    //tareacontext
    const tareasContext = useContext(TareaContext);
    const {agregarTarea, errortarea, validarTarea,obtenerTareas,tareaSeleccionada,actualizarTarea,limpiarTarea}=tareasContext;

    //effect que dectecta si hay una tarea seleccionada

    useEffect(() => {
       if(tareaSeleccionada!==null){
            guardarTarea(tareaSeleccionada);
       }else{
        guardarTarea({
            nombre:''
        })
       }
    }, [tareaSeleccionada]);


    //state de formulario tarea
    const [tarea,guardarTarea]=useState({
        nombre:'',
    })

    //extraer nombre de tarea
    const {nombre}=tarea;
    
      //si no hay proyecto seleccionado 
      if(!proyecto) return null

      //array destructuring para extraer el proyecto actual
      const [proyectoActual]= proyecto;


      //leer los valores del formulario

      const handleChange=e=>{
          guardarTarea({
              ...tarea,
              [e.target.name] : e.target.value
          })
      }

      const onSubmit= e=>{
        e.preventDefault();

        //validar
        if(nombre.trim()===''){
            validarTarea()
            return;
        } 

        //si es edicion o si  nueva tarea
        if(tareaSeleccionada===null){
            //agregar nueva tarea al state de tareas
            tarea.proyecto= proyectoActual._id;
           /*  tarea.estado=false; se quito despues de hacer el back */
            agregarTarea(tarea);
        }else {
            //actualizar tarea existente
            actualizarTarea(tarea)


            //elimina tarea seleccionada del state
            limpiarTarea();
        }

        //pasar la validacion

        

        //obtener y filtar las tareas del proyecto actual
        obtenerTareas(proyectoActual.id)

        //reiniciar el form
        guardarTarea({
            nombre:''
        })
      }

    return ( 
        <div className="formulario">
            <form
                onSubmit={onSubmit}
            >
                <div className="contenedor-iput">
                    <input 
                    className="input-text"
                    type="text" 
                    name="nombre"
                    placeholder="Nombre Tarea..."
                    value={nombre}
                    onChange={handleChange}
                    />
                </div>
                <div className="contenedor-iput">
                    <input 
                    className="btn btn-primario btn-submit btn-block"
                    type="submit"
                    value={tareaSeleccionada ?'Editar Tarea' : "Agregar Tarea"}
                    />
                </div>
            </form>
            {errortarea 
                ? <p className="mensaje error">El nombre de la tarea es obligatorio</p>
                :null
                
                }
        </div>
     );
}
 
export default FormTarea;